import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { Button } from "react-bootstrap";
import { isClientIOS, isClientMobile } from "../ClientInfo/ClientInfo";
import { getAppStoreLinkApple, getAppStoreLinkGoogle } from "./toAppSelectors";
import { cloneElement } from "react";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

const ToAppButton = ({appStoreLinkApple, appStoreLinkGoogle, children, label}) => {
    const {getLangPath} = useLangContext();
    const link = isClientIOS
            ? appStoreLinkApple
            : appStoreLinkGoogle
    const buttonRouteProps = link ? {
        as: 'a',
        href: link
    } : {
        as: 'a',
        href: '/app',
    }

    return (
            isClientMobile && (
                    children
                            ? cloneElement(children, buttonRouteProps)
                            : <Button variant={'outline-primary'} size={'sm'} {...buttonRouteProps}>
                                {label || getLangPath('header.open_app')}
                            </Button>
            )
    )
}

const mapStateToProps = createStructuredSelector({
    appStoreLinkApple: getAppStoreLinkApple,
    appStoreLinkGoogle: getAppStoreLinkGoogle,
})

export default connect(mapStateToProps)(ToAppButton);
